import { listingType } from '../../shared/reducers/category-listing-type.reducer';
import { producerUrlManager } from './producer-url-params.reducer';
import { modals } from '../../../reducers/modals';

export default {
    listingType,
    producerUrlManager,
    modals
};
